import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography, Button, Box, IconButton, Tooltip,
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import EditIcon from '@material-ui/icons/Edit';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    flex: 1,
  },
  addBtn: {
    textTransform: 'none',
    fontSize: 12,
    padding: '4px 10px',
  },
  area: {
    padding: '10px 12px',
    borderLeft: '3px solid #d32f2f',
    background: '#fff5f5',
    borderRadius: 4,
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  areaInfo: {
    flex: 1,
    minWidth: 0,
  },
  areaName: {
    fontSize: 13,
    fontWeight: 500,
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  areaMeta: {
    fontSize: 11,
    color: '#999',
    marginTop: 2,
  },
  emptyBox: {
    padding: 20,
    background: '#f5f5f5',
    borderRadius: 6,
    textAlign: 'center',
    fontSize: 12,
    color: '#999',
  },
}));

const RestrictedAreasSection = ({
  areas = [],
  onDraw,
  onEdit,
  onEditShape,
  onDelete,
  drawing,
  editing,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <div className={classes.header}>
        <LockIcon style={{ fontSize: 18, color: '#666' }} />
        <Typography className={classes.title}>Restricted areas</Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={onDraw}
          className={classes.addBtn}
          startIcon={<AddIcon style={{ fontSize: 14 }} />}
          disabled={disabled || drawing || editing}
        >
          {drawing ? 'Drawing...' : 'Add'}
        </Button>
      </div>

      {areas.length === 0 ? (
        <div className={classes.emptyBox}>
          None defined
          <div style={{ fontSize: 11, marginTop: 4 }}>
            For secure zones that need special access
          </div>
        </div>
      ) : (
        <Box>
          {areas.map((ra) => (
            <div key={ra._id} className={classes.area}>
              <div className={classes.areaInfo}>
                <div className={classes.areaName}>{ra.name || 'Untitled'}</div>
                <div className={classes.areaMeta}>
                  {ra.restrictionDetails?.restrictionType || 'appointment'}
                  {ra.restrictionDetails?.contactName ? ` · ${ra.restrictionDetails.contactName}` : ''}
                </div>
              </div>
              <Tooltip title="Edit details">
                <IconButton size="small" onClick={() => onEdit(ra)} style={{ padding: 2 }}>
                  <EditIcon style={{ fontSize: 14, color: '#666' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit boundary points">
                <IconButton
                  size="small"
                  onClick={() => onEditShape(ra)}
                  disabled={drawing || editing}
                  style={{ padding: 2 }}
                >
                  <EditLocationIcon style={{ fontSize: 15, color: '#d32f2f' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  onClick={() => {
                    if (window.confirm(`Delete "${ra.name || 'this area'}"?`)) {
                      onDelete(ra._id);
                    }
                  }}
                  style={{ padding: 2 }}
                >
                  <DeleteIcon style={{ fontSize: 14, color: '#999' }} />
                </IconButton>
              </Tooltip>
            </div>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default RestrictedAreasSection;
